import type { CustomFlowbiteTheme } from 'flowbite-react';

export const dropdownTheme: CustomFlowbiteTheme['dropdown'] = {
  arrowIcon: 'ml-2 h-4 w-4',
  content: 'py-1 focus:outline-none',
  floating: {
    animation: 'transition-opacity',
    arrow: {
      base: 'absolute z-10 h-2 w-2 rotate-45',
      style: {
        dark: 'bg-titan-night-900',
        light: 'bg-white',
        auto: 'bg-white',
      },
      placement: '-4px',
    },
    base: 'z-10 w-fit rounded divide-y divide-titan-night-100 shadow focus:outline-none',
    content: 'py-1 text-sm text-titan-night-700',
    divider: 'my-1 h-px bg-titan-night-100',
    header: 'block py-2 px-4 text-sm text-titan-night-700',
    hidden: 'invisible opacity-0',
    item: {
      base: 'flex items-center justify-start py-2 px-4 text-sm text-titan-night-700 cursor-pointer w-full hover:bg-titan-night-100 focus:bg-titan-night-100 focus:outline-none',
      icon: 'mr-2 h-4 w-4',
    },
    style: {
      dark: 'bg-titan-night-900 text-white',
      light: 'border border-titan-night-200 bg-white text-titan-night-900',
      auto: 'border border-titan-night-200 bg-white text-titan-night-900',
    },
    target: 'w-fit',
  },
  inlineWrapper: 'flex items-center',
};
